import React from 'react'
import './social.css'
const Social = () => {
    return (
        <div>
            <nav class="social">
                <ul>
                    <li><a href="https://twitter.com/Rohit20023000" target='_blank'><span>Twitter</span> <i class="fa fa-twitter"></i></a></li>
                    <li><a href="https://github.com/rohit0796" target='_blank'><span>Github</span> <i class="fa fa-github"></i></a></li>
                    <li><a href="https://www.linkedin.com/in/rohit--sahu-/" target='_blank'><span>Linkedin</span> <i class="fa fa-linkedin"></i></a></li>
                    <li><a href="https://www.instagram.com/_rohit_kumar_sahu/" target='_blank'><span>Instagram</span> <i class="fa fa-instagram"></i></a></li>
                </ul>
            </nav>

        </div>
    )
}

export default Social
